import React from 'react'
import { Formik, useFormikContext } from 'formik'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'

import FooterButtons from './FooterButtons'
import usePostingNoticeRequestContext from 'hooks/posting_notice_request/usePostingNoticeRequestContext'
import FileAttachDropzone from './FileAttachDropzone'
import { ONE_MB } from 'utils/constants'

function CoverLetter() {
  const { values, setFieldError, errors, handleChange } = useFormikContext()
  const { shippingAddress } = usePostingNoticeRequestContext()

  return (
    <Box sx={{ width: '100%', flex: 1 }}>
      <Box>
        <Card
          sx={{
            p: 6,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Stack spacing={4} width="100%">
            {Boolean(shippingAddress.email) && (
              <Alert severity="info">
                <Typography variant="body1">
                  Generated PDF will be limited to a file size of 10MB.
                </Typography>
              </Alert>
            )}
            <Box width="100%">
              <FileAttachDropzone
                display="Cover Letter Attachment (PDF)"
                name="coverLetter"
                setFieldError={setFieldError}
                error={errors.coverLetter}
                files={values.coverLetter ? [values.coverLetter] : []}
                onChange={(files) => {
                  handleChange({
                    target: { name: 'coverLetter', value: files?.[0] },
                  })
                }}
                onRemove={() => {
                  handleChange({
                    target: { name: 'coverLetter', value: null },
                  })
                }}
              />
            </Box>
            <Box width="100%">
              <FileAttachDropzone
                multiple={!shippingAddress.email}
                display="Other Attachment(s) (PDF)"
                name="attachments"
                setFieldError={setFieldError}
                error={errors.attachments}
                files={values.attachments}
                maxSize={shippingAddress.email ? 10 * ONE_MB : 100 * ONE_MB}
                onChange={(files) => {
                  handleChange({
                    target: { name: 'attachments', value: files },
                  })
                }}
                onRemove={(index) => {
                  const newFiles = [...values.attachments]
                  newFiles.splice(index, 1)
                  handleChange({
                    target: { name: 'attachments', value: newFiles },
                  })
                }}
              />
            </Box>
          </Stack>
        </Card>
        <FooterButtons />
      </Box>
    </Box>
  )
}

function CoverLetterWrapper() {
  const { stage, setStage, setCoverLetter, coverLetter } =
    usePostingNoticeRequestContext()

  return (
    <Formik
      enableReinitialize
      initialValues={coverLetter}
      onSubmit={(values) => {
        setStage(stage + 1)
        setCoverLetter(values)
      }}
    >
      <CoverLetter />
    </Formik>
  )
}

export default CoverLetterWrapper
